import React from "react";
import { useLocation, useHistory, NavLink, Link } from "react-router-dom";
import { connect } from "react-redux";
import Router from "router/router";
import * as NewsAction from "store/news/action";
import * as NewsReducer from "store/news/reducer";
import * as css from "./css/news-category";

function NewsCategory(props) {
  const { className, news, newsAction } = props;
  const { currentCategoryIndex, categoryList } = news;
  const history = useHistory();

  function onClickMenu({ menuType, categoryId }) {
    if (!menuType) {
      menuType = null;
    }
    // window.location.href = `${Router.basename}${Router.News.realPath}?menuType=${menuType}&categoryId=${categoryId}`;
    // if (!id) {
    //   id = null;
    // }
    // newsAction.setMenuType(menuType);
    // newsAction.setCategoryId(id);

    history.replace({
      pathname: `${Router.News.realPath}`,
      search: `menuType=${menuType}&categoryId=${categoryId}`,
    });
  }

  function renderNewsMenu() {
    return categoryList.map((item, index) => {
      if (index === 0) {
        return null;
      }

      const { id: categoryId, name, type: menuType } = item;
      return (
        <Link
          className={`news-item ${
            currentCategoryIndex === index ? "active" : ""
          }`}
          key={index}
          // onClick={() => {
          //   onClickMenu({ menuType, categoryId });
          // }}
          to={{
            pathname: `${Router.News.realPath}`,
            search: `menuType=${menuType}&categoryId=${categoryId}`,
          }}
        >
          <span className="label">{name}</span>
          <div className="active-img-wrapper">
            <img
              src={require("./img/active.png")}
              alt=""
              className="active-img"
            />
          </div>
        </Link>
      );
    });
  }

  return (
    <css.NewsCategory className={className}>
      <css.Title>
        资讯分类
        <div className="bg-img-wrapper">
          <img src={require("./img/title-bg.png")} alt="" className="bg-img" />
        </div>
      </css.Title>
      <css.Content>
        {categoryList.length > 0 && (
          <css.Video
            className={`${currentCategoryIndex === 0 ? "active" : ""}`}
            onClick={() => {
              onClickMenu({
                index: 0,
                menuType: categoryList[0].type,
                id: categoryList[0].id,
              });
            }}
          >
            {categoryList[0].name}
            <div className="bg-img-wrapper">
              <img
                src={require("./img/video-bg.png")}
                alt=""
                className="bg-img"
              />
            </div>

            <div className="active-img-wrapper">
              <img
                src={require("./img/active.png")}
                alt=""
                className="active-img"
              />
            </div>
          </css.Video>
        )}

        <css.News>
          <div className="bg-img-wrapper">
            <img src={require("./img/news-bg.png")} alt="" className="bg-img" />
          </div>
          {renderNewsMenu()}
        </css.News>
      </css.Content>
    </css.NewsCategory>
  );
}

export default connect(
  (state) => {
    const { news } = state;

    return {
      news,
    };
  },
  (f) => ({
    newsAction: {
      setMenuType() {
        f(NewsAction.setMenuType(...arguments));
      },
      setCategoryId() {
        f(NewsAction.setCategoryId(...arguments));
      },
    },
  })
)(NewsCategory);
